import { reactive, watch } from "vue";

const getSavedSetting = (key, defaultValue) => {
  const saved = localStorage.getItem(key);
  return saved !== null ? JSON.parse(saved) : defaultValue;
};

export const settings = reactive({
  sound: getSavedSetting("settings_sound", true),
  isSigned: getSavedSetting("settings_isSigned", true),
  notifications: getSavedSetting("settings_notifications", true),
});

watch(
  () => settings.sound,
  (newVal) => {
    localStorage.setItem("settings_sound", JSON.stringify(newVal));
  }
);

watch(
  () => settings.isSigned,
  (newVal) => {
    localStorage.setItem("settings_isSigned", JSON.stringify(newVal));
  }
);

watch(
  () => settings.notifications,
  (newVal) => {
    localStorage.setItem("settings_notifications", JSON.stringify(newVal));
  }
);
